import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { EmptyState } from '../../../../components/ui/common';
import { summariesSearchSchema, type SummariesSearch } from '../../../../features/B6/search';
import { SummariesTab } from '../../../../features/B6/SummariesTab';
import { useCan, useMe } from '../../../../lib/session';

/** Client page "סיכומים" tab — lane B6-web (manager summaries, D-69). */
export const Route = createFileRoute('/_app/client/$clientId/summaries')({
  validateSearch: (s: Record<string, unknown>): SummariesSearch => summariesSearchSchema.parse(s),
  component: ClientSummariesTab,
});

function ClientSummariesTab() {
  const can = useCan();
  const me = useMe();
  const { clientId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const setSearch = useCallback(
    (patch: Partial<SummariesSearch>, replace = false) =>
      void navigate({ search: (prev) => ({ ...prev, ...patch }), replace }),
    [navigate],
  );
  if (me.data && !can('clients.view')) {
    return (
      <EmptyState
        icon="shield"
        title="אין לך הרשאה לצפות בלקוחות"
        text="מנהל המערכת יכול לתת לך הרשאת צפייה בלקוחות."
      />
    );
  }
  return <SummariesTab clientId={clientId} search={search} setSearch={setSearch} />;
}
